import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../uicomponentcss';


export interface MobileMenuCSSStyle extends UIComponentCSSStyle
{
    getListRowCSSStyle(): object;
    getCloseIconDivCSSStyle(): object;
    getLogoWrapperCSSStyle():object;
    getCloseIconCSSStyle(): object;
    getInnerWrapperCSSStyle():object;
    getIconNameLabelCSSStyle():object;
    getSideBarOpen(isOpen: boolean): object;
    getCategoriesInnerWrapperCSSStyle():object;
    getIconDivCSSStyle():object;
    getDividerCSSStyle():object;
}

export class MobileMenuCSSStyleImpl extends UIComponentCSSStyleImpl implements MobileMenuCSSStyle
{
    getSideBarOpen(isOpen: boolean): object
    {
        return {
            width: isOpen ? "100%" : "0",
            position: "fixed",
            zIndex: "1",
            height: "100%",
            top: "0",
            right: isOpen?"-0px":'-20px',
            backgroundColor: "#ED0C6E",
            overflowX: "hidden",
            transition: "0.5s",
            padding: "0px"
        };
    }
    getCloseIconDivCSSStyle(): object 
    {
        return {
            height: "40px",
            width: "43%",
            display: "inline-block",
            cursor: "pointer"
        };
    }

    getIconNameLabelCSSStyle():object
    {
        return{
            lineHeight:'15px',
            width:'100%',
            fontSize: "16px",
            color:"#ffffff",
            paddingTop: "25px",
            cursor:'pointer',
           fontFamily:this.getContext().getResources().getFontFamily()
         };
    }

    getCategoriesInnerWrapperCSSStyle():object
    {
        return{
            display:"flex",
            flexDirection:'row',
            flexFlow:'row wrap',
            height:'30px',
            cursor:'pointer',
            marginLeft:"30px",
            marginRight:"30px",
            marginTop: "20px",
            // borderBottom: "1px solid ##979797",
            backgroundColor: "#ED0C6E",
    };
    }

    getIconDivCSSStyle():object
    {
        return{
           padding:'9px 6px 0px 6px',
           width:'10%',
           height:'100%',
           cursor:'pointer',
            
        };
    }
    getInnerWrapperCSSStyle():object
    {
        return{ width:'100%',
            display:"flex",
            flexDirection:'row',
            flexFlow:'row wrap',
            height:'41px',
            cursor:'pointer',
            backgroundColor: "#ED0C6E",
    };
    }

    getDividerCSSStyle():object
    {
        return{ width:'100%',
            display:"flex",
            flexDirection:'row',
            flexFlow:'row wrap',
            height:'1px',
            boxSizing: "border-box",
            opacity: '1px',
            paddingTop: "15px",
            borderBottom: "1px solid #ffffff",
    };
    }

    getCloseIconCSSStyle(): object 
    {
        return {
            height: "32px",
            width: "32px",
            marginTop: "5px",
            cursor: "pointer"
        };
    }

    getLogoWrapperCSSStyle():object
    {
        return{
            width:'auto',height:'100%',
            float: "left",
            
            // borderBottom: "1px solid " + this.getResources().getColor(Colors.color_3),

        };
    }
    getWrapperCSSStyle(): object
    {
        return {
            listStyleType: "none",
            width: "100%",
            height: "78%",
            display: "flex",
            textAlign: "center",
            justifyContent: 'center', 
            flexFlow: "row wrap"
        };
    }
    
    getListRowCSSStyle(): object 
    {
        return {
            width: '100%', 
            display: 'flex', 
            alignItems: 'center', 
            marginTop: "20px",
            textAlign: "center",
            justifyContent: 'flex-center', 
            borderRadius: '8px'
        };
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/mobilemenu/mobilemenucss.tsx